import { Link } from "react-router-dom";
import { navigationId } from "./navigationGroups";

export const GroupedNavigation = ({ groups, pathname, scope, onNavigate, layout = "stack", exact = false }) => (
  <div className={`grouped-navigation grouped-navigation--${layout}`} data-testid={`${scope}-groups`}>
    {groups.map(group => (
      <section className="navigation-group" key={group.id} aria-labelledby={group.label ? `${scope}-${group.id}-heading` : undefined} aria-label={group.label ? undefined : group.items[0]?.label} data-testid={`${scope}-group-${group.id}`}>
        {group.label && <h2 id={`${scope}-${group.id}-heading`} className="navigation-group-heading" data-testid={`${scope}-heading-${group.id}`}>{group.label}</h2>}
        <div className="navigation-group-links">
          {group.items.map(item => {
            const Icon = item.icon;
            const active = pathname === item.path || (!exact && item.path !== "/dashboard" && pathname.startsWith(item.path + "/"));
            return (
              <Link key={item.path} to={item.path} onClick={onNavigate}
                className={`workspace-nav-link${active ? " is-active" : ""}`}
                aria-current={active ? "page" : undefined}
                data-testid={`${scope === "studio-desktop" ? "nav" : scope}-${navigationId(item.label)}`}>
                {Icon && <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />}
                <span>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </section>
    ))}
  </div>
);